<div class="hotel-t-content" style="position: relative" [ngStyle]="{ 'margin-bottom': componentResults ? '70px' : '35px' }">
  <div *ngIf="componentResults" class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="d-flex align-items-center">
      <img src="../../../../../assets/img/app/categories-search-box/ima_hotel.svg" style="width: 26px" alt="" />
      <h3 class="mb-0 ml-2" style="font-family: &quot;Rubik&quot;, serif">Editar búsqueda de alojamiento</h3>
    </div>
    <div>
      <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
        <span aria-hidden="true" style="font-size: 50px !important; font-weight: 100 !important">&times;</span>
      </button>
    </div>
  </div>

  <usb-edit-search-modal *ngIf="componentResults && loadingData"></usb-edit-search-modal>

  <form *ngIf="!loadingData" (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="d-flex mb-3 mt-3 position-relative" style="gap: 1em">
      <div class="d-flex accommodation-types" style="gap: 1em">
        <button
          *ngFor="let type of accommodationTypes"
          type="button"
          class="accommodation-type"
          [class.active]="selectedAccommodationType === type.key"
          [disabled]="!type.enabled"
          (click)="selectAccommodationType(type)"
        >
          {{ type.label }}
        </button>
      </div>
      <div class="w-100" id="form-destination">
        <div class="position-relative">
          <!-- <ng-container *ngIf="destiny === undefined"> -->

          <input
            name="destino"
            matInput
            maxlength="50"
            class="form-control input-search-box"
            style="background-color: white"
            #destination
            formControlName="destination"
            placeholder="Destino"
            [matAutocomplete]="autoDestination"
          />
          <img
            *ngIf="destiny === undefined"
            class="destination-arrow"
            width="10"
            height="10"
            src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
            alt=""
          />

          <mat-autocomplete
            #autoDestination="matAutocomplete"
            [displayWith]="displayFn"
            (optionSelected)="updateMySelection($event.option.value)"
          >
            <!-- UBICACIONES -->
            <ng-container *ngIf="destinationOptions | async as options">
              <ng-container *ngFor="let item of options">
                <ng-container *ngIf="item.type === 'city'">
                  <mat-option
                    disabled
                    style="background-color: #f4f4f4; height: 42px"
                    *ngIf="options && options.length > 0 && item.cities.length > 0"
                  >
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center" style="gap: 0.25em">
                        <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                        <span
                          class="mt-1"
                          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                          >Ubicación</span
                        >
                      </div>
                      <div>
                        <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                          >{{ item.cities.length }} resultados</span
                        >
                      </div>
                    </div>
                  </mat-option>
                  <ng-container *ngFor="let city of item.cities">
                    <mat-option [value]="city">
                      <div class="d-flex align-items-center" style="gap: .75em;margin-left: 9px">
                        <img src="{{city?.country_logo}}" style="width: 16px; height: 16px; border-radius: 50%;" />
                        <p
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                        >
                          {{ capitalize(city.city_name) }},
                          <span
                            class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                            >{{ capitalize(city.city_province) }}{{ city.city_province ? "," : "" }}
                            {{ capitalize(city.country_name) }}</span
                          >
                        </p>
                      </div>
                    </mat-option>
                  </ng-container>
                </ng-container>
              </ng-container>

              <!-- HOTELES -->
              <ng-container *ngFor="let item of options">
                <ng-container *ngIf="item.type === 'hotel' && !isBoatSearch">
                  <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.hotels && item.hotels.length > 0">
                    <div class="d-flex justify-content-between">
                      <div class="d-flex align-items-center" style="gap: 0.25em">
                        <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                        <span
                          class="mt-1"
                          style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                          >Hotel</span
                        >
                      </div>
                      <div>
                        <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                          >{{ item.hotels.length }} resultados</span
                        >
                      </div>
                    </div>
                  </mat-option>
                  <ng-container *ngFor="let hotel of item.hotels">
                    <mat-option [value]="hotel">
                      <div class="d-flex align-items-center" style="gap: .75em;margin-left: 9px">
                        <img src="{{hotel?.country_logo}}" style="width: 16px; height: 16px; border-radius: 50%;" />
                        <p
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                        >
                           {{ capitalize(hotel.name) }},
                          <span
                            class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                            > {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? "," : "" }} {{ capitalize(hotel.city_province)
                            }}{{ hotel.city_province ? "," : "" }}
                            {{ capitalize(hotel.country_name) }}</span
                          >
                        </p>
                      </div>
                    </mat-option>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </mat-autocomplete>

          <!-- </ng-container> -->

          <ng-container *ngIf="destiny !== undefined">
            <!-- <span class="container-input-icon-cancel"> -->
            <!-- <input
                      id="nationality"
                      name="nationality"
                      matInput
                      class="form-control input-search-box input-square-container"
                      style="background-color: white;"
                      aria-label="destination"
                      value="{{hotel_name !== '' ? hotel_name+', '+destiny+', '+country_name : destiny+province_name+', '+country_name}}"
                      type="text"
                      readonly
                /> -->
            <span class="square-class-secondArrival">
              <div class="container-square-secondArrival">
                <i
                  class="bi bi-x x-icon-cancel"
                  (mouseenter)="isHoveredCancelDate = true"
                  (mouseleave)="isHoveredCancelDate = false"
                  tooltip="Eliminar destino"
                  placement="bottom"
                  (click)="resetDestiny()"
                ></i>
              </div>
            </span>
            <!-- </span> -->
          </ng-container>

          <span
            style="
              color: red;
              font-family: &quot;Poppins&quot;;
              font-size: 10px !important;
              position: absolute;
              bottom: -16px;
              left: 10px;
              line-height: 1;
            "
            *ngIf="_form.get('destination').touched && _form.get('destination').hasError('required')"
            >Este campo es requerido. Escriba y seleccione un destino válido de la lista.</span
          >
          <span
            style="
              color: red;
              font-family: &quot;Poppins&quot;;
              font-size: 10px !important;
              position: absolute;
              bottom: -16px;
              left: 10px;
              line-height: 1;
            "
            *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidcountry')"
            >Formato de destino no válido. Seleccione un destino válido de la lista.</span
          >
          <span
            style="
              color: red;
              font-family: &quot;Poppins&quot;;
              font-size: 10px !important;
              position: absolute;
              bottom: -16px;
              left: 10px;
              line-height: 1;
            "
            *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidDestination')"
            >Destino no válido, seleccione un destino válido de la lista.</span
          >
        </div>
      </div>
    </div>
    <div class="d-flex" style="gap: 1em">
      <div class="search-col position-relative" id="form-destination">
        <div>
          <input
            type="hidden"
            readonly
            formControlName="arrivalDateDepartureDate"
            autocomplete="off"
            class="form-control ngxDaterangepickerMd"
            ngxDaterangepickerMd
            [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
            startKey="start"
            endKey="end"
            [(ngModel)]="dateRange"
            [autoApply]="true"
            [closeOnAutoApply]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (startDateChanged)="startDateClicked($event)"
            (endDateChanged)="endDateClicked($event)"
            name="daterange"
            #dateRangePicker
          />
          <input
            type="text"
            readonly
            [value]="dateRangeLabel"
            placeholder="  Check-in - check-out"
            class="form-control input-search-box ngx-daterangepicker-action"
            (click)="openDatePickerSimple()"
            id="dateRangePickerTrigger"
          />
        </div>
        <span
          *ngIf="dateRangeInvalid || isDateRangeValid()"
          style="
            color: red;
            font-family: &quot;Poppins&quot;;
            font-size: 10px !important;
            position: absolute;
            bottom: -16px;
            left: 10px;
            line-height: 1;
          "
          >Este campo es requerido.</span
        >
      </div>
      <div *ngIf="!isBoatSearch" class="search-col position-relative" id="form-destination">
        <ng-container *ngIf="selectNationalityName === ''">
          <input
            id="nationality"
            name="nationality"
            formControlName="nationality"
            matInput
            class="form-control input-search-box"
            style="background-color: white"
            (input)="filterCountries($event.target.value)"
            (focus)="getCountries()"
            aria-label="nationality"
            [matAutocomplete]="auto"
            placeholder="Nacionalidad"
            type="text"
          />
          <mat-autocomplete
            id="matCountry"
            #matCountry
            #auto="matAutocomplete"
            [displayWith]="displayCountry"
            (optionSelected)="updateMySelectionNationality($event.option.value)"
          >
            <mat-option
              *ngFor="let country of filteredCountries"
              style="font-family: &quot;Poppins&quot;, sans-serif; padding: 0px 10px !important; height: 35px !important"
              [value]="country.country_code"
            >
              {{ country.country_name }}</mat-option
            >
          </mat-autocomplete>
        </ng-container>

        <ng-container *ngIf="selectNationalityName !== ''">
          <span class="container-input-icon-cancel" style="position: relative">
            <input
              id="nationality"
              name="nationality"
              matInput
              class="form-control input-search-box input-square-container"
              style="background-color: white"
              aria-label="nationality"
              value="{{ selectNationalityName }}"
              type="text"
              readonly
            />
            <span class="square-class-secondArrival">
              <div class="container-square-secondArrival">
                <i
                  class="bi bi-x x-icon-cancel"
                  (mouseenter)="isHoveredCancelDate = true"
                  (mouseleave)="isHoveredCancelDate = false"
                  tooltip="Eliminar nacionalidad"
                  placement="bottom"
                  (click)="resetNationality()"
                ></i>
              </div>
            </span>
          </span>
        </ng-container>
        <span
          style="
            color: red;
            font-family: &quot;Poppins&quot;;
            font-size: 10px !important;
            position: absolute;
            bottom: -16px;
            left: 10px;
            line-height: 1;
          "
          *ngIf="_form.get('nationality').touched && _form.get('nationality').hasError('required')"
          >Este campo es requerido.</span
        >
      </div>

      <div class="search-col" id="form-destination">
        <button
          type="button"
          #triggerButton
          class="d-flex justify-content-between align-items-center form-control btn-usb-rp element-config-passenger"
          (click)="_openModal(); expandedConfigPassenger()"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="false"
          style="
            font-family: &quot;Poppins&quot;, sans-serif !important;
            font-size: 14px !important;
            font-weight: 600 !important;
            color: #464646;
          "
        >
          {{ roomsAndPassengers }}
          <img width="10" height="10" src="../../../../../assets/img/app/little-icons/arrow-down-black.svg" />
        </button>
        <div *ngFor="let room of _form.value['room']; let i = index">
          <span class="help-block text-danger" *ngIf="(validate || (_close && isCollapsed)) && room['qtyAdults'] == 0"
            >Al menos selecciona 1 adulto en la habitación {{ i + 1 }}.</span
          >
        </div>
        <div
          (click)="_over()"
          (collapsed)="clickOutside($event)"
          (expanded)="($event)"
          [collapse]="!isCollapsed || _close"
          class="justify-content-end config-passenger"
        >
          <div class="row">
            <div style="position: relative; width: 100%">
              <!-- Rooms And Passengers Modal -->
              <div
                #cardSelectorRoom
                id="cardSelectorRoom"
                [style.transform]="getCardTransform()"
                class="card py-4 pl-5 scrollable-card-container"
                [ngClass]="{ 'pr-4': formRoom(_form, 'room').length > 3, 'pr-5': formRoom(_form, 'room').length <= 3 }"
                style="width: auto !important; min-width: 100%"
              >
                <!-- Adults And Childrens header -->
                <div class="d-flex align-items-center justify-content-center" style="gap: 40px;">
                  <!-- Adults -->
                  <div class="d-flex flex-column align-items-center justify-content-center">
                    <label
                      class="mb-0"
                      style="
                        font-family: &quot;Rubik&quot; !important;
                        font-size: 14px !important;
                        font-weight: 600 !important;
                        line-height: 1;
                      "
                      for="adults"
                      >Adultos</label
                    >
                    <p
                      class="mb-0"
                      style="
                        font-family: &quot;Rubik&quot; !important;
                        font-size: 11px !important;
                        font-weight: 400 !important;
                        line-height: 1;
                      "
                    >
                      + de 18 años
                    </p>
                  </div>

                  <!-- Childrens -->
                  <div class="container-label d-flex">
                    <div class="d-flex flex-column align-items-start">
                      <div class="d-flex" style="line-height: 1">
                        <label
                          class="mb-0"
                          style="
                            font-family: &quot;Rubik&quot; !important;
                            font-size: 14px !important;
                            font-weight: 600 !important;
                            line-height: 1;
                          "
                          for="childs"
                          >Niños</label
                        >
                        <div class="info-tool d-flex flex-column position-relative">
                          <img
                            #iconInfo
                            src="../../../../../assets/icons/search-box/Informativo-01.svg"
                            width="13px"
                            alt=""
                          />
                          <span class="tooltip-info">Los bebes (0 - 2 años sin cumplir) deben indicarse como niños</span>
                        </div>
                      </div>
                      <p
                        class="mb-0"
                        style="
                          font-family: &quot;Rubik&quot; !important;
                          font-size: 11px !important;
                          font-weight: 400 !important;
                          line-height: 1;
                        "
                      >
                        - de 18 años
                      </p>
                    </div>
                  </div>
                </div>

                <div class="room-content" [ngClass]="{ 'pr-5': formRoom(_form, 'room').length > 3 }">
                  <ng-container formArrayName="room">
                    <div
                      *ngFor="let item of formRoom(_form, 'room'); let i = index"
                      class="d-flex flex-row col-12 align-items-center justify-content-between p-2"
                    >
                      <div [formGroupName]="i" style="width: 100%;" [ngStyle]="{ 'border-bottom': formRoom(item, 'childsage').length > 0 ? 'none' : '2px dotted #9c9c9c'}">
                        <div class="d-flex flex-column">
                          <div class="d-flex flex-row align-items-center justify-content-between p-0 pb-3">
                            <div>
                              <div
                                class="mr-2 ml-1"
                                style="font-family: &quot;Rubik&quot;; font-size: 14px; font-weight: 500; width: 50px"
                              >
                                <ng-container *ngIf="!isBoatSearch">Hab: {{ i + 1 }}</ng-container>
                              </div>
                            </div>
                            <div class="d-flex flex-column align-items-center p-0 m-0 mr-2 ml-3">
                              <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                                <button
                                  type="button"
                                  class="pr-2"
                                  style="border: none; background-color: transparent"
                                  (click)="decrementPassengerAdult(i, $event)"
                                  [disabled]="getPassengerCountAdult(i) <= 1"
                                >
                                  <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                                </button>

                                <input
                                  type="number"
                                  class="form-control text-center"
                                  style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                                  [value]="getPassengerCountAdult(i)"
                                  [min]="1"
                                  [max]="10"
                                  (change)="validatePassengerInput($event, i)"
                                  (keydown)="handleAdultInput($event, i)"
                                  (blur)="handleAdultBlur($event, i)"
                                  (click)="preventModalClose($event)"
                                  name="adults"
                                />

                                <button
                                  type="button"
                                  class="pl-2"
                                  style="border: none; background-color: transparent"
                                  (click)="incrementPassengerAdult(i, $event)"
                                  [disabled]="getPassengerCountAdult(i) >= 10"
                                >
                                  <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                                </button>
                              </div>
                            </div>
                            <div class="d-flex flex-column align-items-center p-0 m-0 mr-3 ml-2">
                              <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                                <button
                                  type="button"
                                  style="border: none; background-color: transparent"
                                  class="pr-2"
                                  (click)="decrementPassengerChildren(i, item, $event)"
                                  [disabled]="getPassengerCountChildren(i) <= 0"
                                >
                                  <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                                </button>

                                <input
                                  type="number"
                                  class="form-control text-center"
                                  style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                                  [value]="getPassengerCountChildren(i)"
                                  [min]="0"
                                  [max]="10"
                                  (change)="validatePassengerInput($event, i)"
                                  (keydown)="handleChildrenInput($event, i)"
                                  (blur)="handleChildrenBlur($event, i)"
                                  (click)="preventModalClose($event)"
                                  name="children"
                                />

                                <button
                                  type="button"
                                  style="border: none; background-color: transparent"
                                  class="pl-2"
                                  (click)="incrementPassengerChildren(i, item, $event)"
                                  [disabled]="getPassengerCountChildren(i) >= 10"
                                >
                                  <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                                </button>
                              </div>
                            </div>
                            <!-- Children age inputs -->
                            <div id="childrenAges" class="d-flex flex-column ml-2" *ngIf="item.get('childsage').length > 0">
                              <div *ngIf="hasChildAgeError(item, 'childsage')">
                                <span class="help-block text-danger d-flex w-100 text-nowrap"> La edad de los niños es incorrecta </span>
                              </div>
                            </div>
                            <div *ngIf="!isBoatSearch" class="p-0 d-flex flex-column ml-auto ml-2">
                              <button
                                type="button"
                                (click)="_removeRoom(i, $event)"
                                class="ml-2 btn btn-outline-danger col-12 input-age btn-sm"
                                style="
                                  min-height: 35px !important;
                                  width: 45px !important;
                                  height: 45px !important;
                                  border-radius: 8px;
                                  border: 1px solid #ced4da !important;
                                "
                                [disabled]="_form.get('qtyProduct').value === 1"
                              >
                                <i class="bi bi-x-lg" style="color: black; font-size: 16px; -webkit-text-stroke: 0.5px"></i>
                              </button>
                            </div>
                          </div>
                          <div>
                            <div
                              *ngIf="formRoom(item, 'childsage').length > 0"
                              class="d-flex flex-column p-4 m-0"
                              style="border-radius: 10px; background-color: #f4f4f4"
                            >
                              <div class="d-flex flex-column align-items-start mb-3 ml-1">
                                <label
                                  class="mb-0"
                                  style="
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                    line-height: 1;
                                    text-wrap: nowrap;
                                  "
                                  for="adults"
                                  >Edad niños <span style="font-weight: 400 !important; font-size: 12px !important;">- de 18 años</span></label
                                >
                              </div>
                              <!-- Primera fila (índices 0-4) -->
                              <div class="d-flex mb-3">
                                <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                  <div *ngIf="j >= 0 && j <= 3">
                                    <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                      <select
                                        name="age"
                                        id="age"
                                        formControlName="age"
                                        [ngStyle]="{ 'margin-left': j > 0 ? '1em' : '' }"
                                        class="form-control custom-select-arrow"
                                        style="
                                          height: 35px !important;
                                          padding: 0 !important;
                                          width: 60px !important;
                                          font-family: &quot;Rubik&quot; !important;
                                          font-size: 14px !important;
                                          font-weight: 600 !important;
                                          text-align: left;
                                          padding-left: 13px !important;
                                          background-color: #FFFFFF !important;
                                          border-radius: 12px;
                                        "
                                      >
                                        <ng-container *ngFor="let value of agesChildsArr()">
                                          <option value="{{ value }}">{{ value }}</option>
                                        </ng-container>
                                      </select>
                                      <span
                                        style="
                                          position: absolute;
                                          top: 42%;
                                          right: 0.5em;
                                          width: 0;
                                          height: 0;
                                          border-left: 4px solid transparent;
                                          border-right: 4px solid transparent;
                                        "
                                        [ngStyle]="{
                                          'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                        }"
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Segunda fila (índices 5-9) -->
                              <div class="d-flex mb-3">
                                <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                  <div *ngIf="j >= 4 && j <= 7">
                                    <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                      <select
                                        name="age"
                                        id="age"
                                        formControlName="age"
                                        [ngStyle]="{ 'margin-left': j > 4 ? '1em' : '' }"
                                        class="form-control custom-select-arrow"
                                        style="
                                          height: 35px !important;
                                          padding: 0 !important;
                                          width: 60px !important;
                                          font-family: &quot;Rubik&quot; !important;
                                          font-size: 14px !important;
                                          font-weight: 600 !important;
                                          text-align: left;
                                          padding-left: 13px !important;
                                          background-color: #FFFFFF !important;
                                          border-radius: 12px;
                                        "
                                      >
                                        <ng-container *ngFor="let value of agesChildsArr()">
                                          <option value="{{ value }}">{{ value }}</option>
                                        </ng-container>
                                      </select>
                                      <span
                                        style="
                                          position: absolute;
                                          top: 42%;
                                          right: 1em;
                                          width: 0;
                                          height: 0;
                                          border-left: 4px solid transparent;
                                          border-right: 4px solid transparent;
                                        "
                                        [ngStyle]="{
                                          'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                        }"
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Tercera fila (índices 8 - 9) -->
                              <div class="d-flex">
                                <div formArrayName="childsage" *ngFor="let age of formRoom(item, 'childsage'); let j = index">
                                  <div *ngIf="j >= 8 && j <= 9">
                                    <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                      <select
                                        name="age"
                                        id="age"
                                        formControlName="age"
                                        [ngStyle]="{ 'margin-left': j === 9 ? '1em' : '' }"
                                        class="form-control custom-select-arrow"
                                        style="
                                          height: 35px !important;
                                          padding: 0 !important;
                                          width: 60px !important;
                                          font-family: &quot;Rubik&quot; !important;
                                          font-size: 14px !important;
                                          font-weight: 600 !important;
                                          text-align: left;
                                          padding-left: 13px !important;
                                          background-color: #FFFFFF !important;
                                          border-radius: 12px;
                                        "
                                      >
                                        <ng-container *ngFor="let value of agesChildsArr()">
                                          <option value="{{ value }}">{{ value }}</option>
                                        </ng-container>
                                      </select>
                                      <span
                                        style="
                                          position: absolute;
                                          top: 42%;
                                          right: 1em;
                                          width: 0;
                                          height: 0;
                                          border-left: 4px solid transparent;
                                          border-right: 4px solid transparent;
                                        "
                                        [ngStyle]="{
                                          'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                        }"
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div
                  class="py-2 row"
                  [ngClass]="{ 'pr-5': formRoom(_form, 'room').length > 3, 'pr-3': formRoom(_form, 'room').length <= 3 }"
                >
                  <div class="col-6 p-2">
                    <button
                      type="button"
                      *ngIf="_form.get('qtyProduct').value < 7 && !isBoatSearch"
                      (click)="_addRoom($event)"
                      class="badge btn-choice-add"
                      style="background-color: transparent; min-width: 145px; width: 100%; height: 36px"
                      [ngStyle]="{ border: '1px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                    >
                      Agregar Habitación
                    </button>

                    <span class="errors" *ngIf="_form.get('qtyProduct').value === 7">Máximo 7 habitaciones</span>
                  </div>

                  <div class="col-6 p-2">
                    <button
                      (click)="_confirm($event)"
                      [attr.aria-expanded]="!isCollapsed"
                      aria-controls="false"
                      class="badge btn-choice-confirm"
                      style="border: none; min-width: 145px; width: 100%; height: 36px"
                      type="button"
                      [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                    >
                      Confirmar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="search-col">
        <button
          *ngIf="!userService._isGuest && userService.itineraryActive.length === 0"
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
          style="font-weight: 600 !important;"
          (click)="fileActive()"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="button"
        >
          <span>BUSCAR</span>
        </button>
        <button
          *ngIf="!userService._isGuest && userService.itineraryActive.length > 0 && validateButtonSearch"
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
          style="font-weight: 600 !important;"
          (click)="filePaid()"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="button"
        >
          <span style="font-weight: 600 !important; text-transform: uppercase;">BUSCAR</span>
        </button>
        <button
          *ngIf="userService._isGuest || (userService.itineraryActive.length > 0 && !validateButtonSearch)"
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
          style="font-weight: 600 !important;"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="submit"
        >
          <span style="font-weight: 600 !important; text-transform: uppercase;">BUSCAR</span>
        </button>
      </div>
    </div>
    <div *ngIf="isBoatSearch" class="d-flex flex-wrap mt-3" style="gap: 0.5em">
      <button
        *ngFor="let option of dateFlexOptions"
        type="button"
        class="date-flex-option"
        [class.active]="selectedDateFlex === option.value"
        (click)="selectedDateFlex = option.value"
      >
        {{ option.label }}
      </button>
    </div>
  </form>
</div>

<div class="modal" [ngClass]="{ show: showModal }">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header d-flex align-items-center justify-content-end" [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }" style="padding: 5px !important;">
        <button type="button" class="close-btn" aria-label="Close" (click)="confirmAction()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="modal-body">
        <img src="../../../../../assets/icons/itinerary-detail/ALERTA-01.svg" width="40" />

        <h5 class="modal-title mt-2 text-black">{{ titleModal }}</h5>
        <p class="mb-1 modal-body-text">
          <span style="font-weight: 500">Cree un file</span> <br />
          en la barra superior para poder <br /> iniciar una busqueda
        </p>
      </div>
    </div>
  </div>
</div>
